import type { ModeloDefaultProps } from "../../banner-fixo.props"
import ConteudoBanner from "../conteudoBanner/ConteudoBanner"

export default function Modelo01({ data }: Readonly<ModeloDefaultProps>) {

    const banners = data.banners.slice(0, 4)
    const device = data.device

    return (
        <div className="fixed-banners fixed-banners-tipo1 container">
            <div className="item-banner flex center justify-center">
                {banners[0] && (
                    <div className="banner-size">
                        <ConteudoBanner data={{
                            banner: banners[0],
                            device
                        }} />
                    </div>
                )}

                <div className="banner-column flex column">
                    {banners[1] && (
                        <div>
                            <ConteudoBanner data={{
                                banner: banners[1],
                                device
                            }} />
                        </div>
                    )}
                    <div className="banner-row flex center">
                        {banners.slice(2, 4).map(currentBanner => (
                            <ConteudoBanner key={currentBanner.id} data={{
                                banner: currentBanner,
                                device
                            }} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}